module.exports = __webpack_public_path__ + "static/media/009.ec5667f7.jpg";